import { Component, input } from '@angular/core';
import { BarInputs } from '@charts';
import { BarChartComponent } from "../bar-chart";

@Component({
  selector: 'ui-rsabt-voltage-imbalance-chart',
  imports: [BarChartComponent],
  template: `
    <ui-bar-chart [barInputs]="barInputs()" />
  `
})

export class RsabtVoltageImbalanceChartComponent {
  barInputs = input.required<BarInputs>();
}
